"use client";

import { useState } from 'react';

export default function ManufacturingDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO DASHBOARD',
      subtitle: 'Executive Manufacturing Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          {/* Background */}
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          {/* Header bar */}
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Manufacturing Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards Row */}
          {[
            { x: 16, label: 'Revenue / Product Line', value: '₹142Cr', sub: '+8.2% MoM', color: '#1B2845' },
            { x: 186, label: 'Plant Utilization', value: '78%', sub: 'Target: 85%', color: '#C5A572' },
            { x: 356, label: 'Cost Per Unit', value: '₹847', sub: '↓ 3.1% vs last month', color: '#16a34a' },
            { x: 526, label: 'Inventory Turnover', value: '6.8×', sub: 'Industry avg: 5.2×', color: '#1B2845' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
              <text x={kpi.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi.sub}</text>
            </g>
          ))}

          {/* Revenue by Product Line Bar Chart */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue by Product Line</text>
          {[
            { label: 'Auto Parts', val: 180, color: '#1B2845' },
            { label: 'Electronics', val: 140, color: '#C5A572' },
            { label: 'Machinery', val: 110, color: '#3b82f6' },
            { label: 'Packaging', val: 85, color: '#8b5cf6' },
            { label: 'Chemicals', val: 65, color: '#10b981' },
          ].map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar.label}</text>
              <rect x="110" y={163 + i * 24} width={bar.val} height="14" fill={bar.color} rx="2" opacity="0.85" />
              <text x={216 + bar.val} y={175 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">₹{bar.val}Cr</text>
            </g>
          ))}

          {/* Plant Profitability Heatmap */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Plant Profitability Heatmap</text>
          {[
            { plant: 'Plant A — Mumbai', margin: '18.4%', color: '#16a34a', w: 200 },
            { plant: 'Plant B — Pune', margin: '14.2%', color: '#65a30d', w: 155 },
            { plant: 'Plant C — Chennai', margin: '11.8%', color: '#ca8a04', w: 128 },
            { plant: 'Plant D — Ahmedabad', margin: '8.5%', color: '#ea580c', w: 92 },
            { plant: 'Plant E — Hyderabad', margin: '6.1%', color: '#dc2626', w: 66 },
          ].map((p, i) => (
            <g key={i}>
              <text x="370" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{p.plant}</text>
              <rect x="490" y={163 + i * 24} width={p.w} height="14" fill={p.color} rx="2" opacity="0.75" />
              <text x="496" y={175 + i * 24} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{p.margin}</text>
            </g>
          ))}

          {/* Production Volume Trend */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Production Volume Trend (Units/Month)</text>
          <polyline points="50,395 130,380 210,385 290,365 370,370 450,350 530,345 620,330 680,320" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="50,395 130,380 210,385 290,365 370,370 450,350 530,345 620,330 680,320 680,400 50,400 Z" fill="#1B2845" opacity="0.06" />
          {[50,130,210,290,370,450,530,620,680].map((x, i) => (
            <circle key={i} cx={x} cy={[395,380,385,365,370,350,345,330,320][i]} r="3" fill="#C5A572" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep'].map((m, i) => (
            <text key={i} x={[50,130,210,290,370,450,530,620,680][i] - 8} y="408" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
    {
      title: 'PLANT OPERATIONS DASHBOARD',
      subtitle: 'Machine & Line Performance Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Plant Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* OEE KPI Cards */}
          {[
            { x: 16, label: 'Overall OEE', value: '76.4%', color: '#C5A572' },
            { x: 186, label: 'Machine Uptime', value: '91.2%', color: '#16a34a' },
            { x: 356, label: 'Throughput vs Target', value: '94.8%', color: '#1B2845' },
            { x: 526, label: 'Active Alerts', value: '3', color: '#dc2626' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Machine Utilization Grid */}
          <rect x="16" y="128" width="330" height="190" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Machine Utilization by Line (OEE %)</text>
          {[
            ['Line A-1','88%','#16a34a'],['Line A-2','82%','#65a30d'],['Line B-1','76%','#ca8a04'],
            ['Line B-2','71%','#ea580c'],['Line C-1','65%','#dc2626'],['Line C-2','91%','#16a34a'],
          ].map(([line, pct, color], i) => (
            <g key={i}>
              <text x="28" y={168 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">{line}</text>
              <rect x="90" y={156 + i * 24} width={200} height="14" fill="#f3f4f6" rx="3" />
              <rect x="90" y={156 + i * 24} width={parseInt(pct) * 2} height="14" fill={color as string} rx="3" opacity="0.8" />
              <text x="298" y={168 + i * 24} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{pct}</text>
            </g>
          ))}

          {/* Downtime Alerts */}
          <rect x="358" y="128" width="326" height="190" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Downtime Alerts</text>
          {[
            { machine: 'CNC Machine B-2', type: 'Bearing wear', severity: 'HIGH', color: '#dc2626', bg: '#fef2f2' },
            { machine: 'Press Line A-3', type: 'Vibration anomaly', severity: 'MED', color: '#ea580c', bg: '#fff7ed' },
            { machine: 'Conveyor C-1', type: 'Belt tension low', severity: 'LOW', color: '#ca8a04', bg: '#fefce8' },
          ].map((alert, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 50} width="302" height="40" fill={alert.bg} rx="6" />
              <text x="382" y={174 + i * 50} fill="#374151" fontSize="10" fontWeight="bold" fontFamily="sans-serif">{alert.machine}</text>
              <text x="382" y={188 + i * 50} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{alert.type}</text>
              <rect x="610" y={162 + i * 50} width="52" height="18" fill={alert.color} rx="4" />
              <text x="636" y={175 + i * 50} fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif" textAnchor="middle">{alert.severity}</text>
            </g>
          ))}

          {/* Shift Productivity */}
          <rect x="16" y="330" width="668" height="78" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="348" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Shift Productivity Leaderboard</text>
          {[
            { shift: 'Morning Shift A', units: 2840, target: 3000, color: '#1B2845' },
            { shift: 'Afternoon Shift B', units: 2650, target: 3000, color: '#C5A572' },
            { shift: 'Night Shift C', units: 2420, target: 3000, color: '#6b7280' },
          ].map((s, i) => (
            <g key={i}>
              <text x={28 + i * 230} y="366" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{s.shift}</text>
              <rect x={28 + i * 230} y="370" width="200" height="10" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 230} y="370" width={s.units / s.target * 200} height="10" fill={s.color} rx="3" opacity="0.8" />
              <text x={28 + i * 230} y="394" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.units.toLocaleString()} units</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'SUPPLY CHAIN & INVENTORY DASHBOARD',
      subtitle: 'Inventory & Supplier Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Supply Chain & Inventory Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Inventory Accuracy', value: '97.8%', color: '#16a34a' },
            { x: 186, label: 'Stockout Risk Items', value: '4', color: '#dc2626' },
            { x: 356, label: 'Supplier On-Time %', value: '88.3%', color: '#C5A572' },
            { x: 526, label: 'Warehouse Utilization', value: '72%', color: '#1B2845' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Raw Material Stock Levels */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Raw Material Stock Levels</text>
          {[
            { mat: 'Steel Coils', pct: 82, color: '#16a34a' },
            { mat: 'Aluminium Sheets', pct: 65, color: '#65a30d' },
            { mat: 'Copper Wire', pct: 41, color: '#ca8a04' },
            { mat: 'Plastic Pellets', pct: 28, color: '#ea580c' },
            { mat: 'Rubber Compounds', pct: 15, color: '#dc2626' },
          ].map((m, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">{m.mat}</text>
              <rect x="140" y={156 + i * 26} width="160" height="14" fill="#f3f4f6" rx="3" />
              <rect x="140" y={156 + i * 26} width={m.pct * 1.6} height="14" fill={m.color} rx="3" opacity="0.8" />
              <text x="308" y={168 + i * 26} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{m.pct}%</text>
            </g>
          ))}

          {/* Demand Forecast vs Production Plan */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Demand Forecast vs Production Plan</text>
          <polyline points="380,285 420,265 460,270 500,250 540,255 580,235 620,230 660,215" fill="none" stroke="#1B2845" strokeWidth="2" strokeLinecap="round" />
          <polyline points="380,290 420,275 460,268 500,260 540,258 580,245 620,238 660,225" fill="none" stroke="#C5A572" strokeWidth="2" strokeDasharray="5 3" strokeLinecap="round" />
          {[380,420,460,500,540,580,620,660].map((x, i) => (
            <circle key={i} cx={x} cy={[285,265,270,250,255,235,230,215][i]} r="3" fill="#1B2845" />
          ))}
          <text x="370" y="305" fill="#1B2845" fontSize="8" fontFamily="sans-serif">— Demand Forecast</text>
          <text x="450" y="305" fill="#C5A572" fontSize="8" fontFamily="sans-serif">- - Production Plan</text>
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'].map((m, i) => (
            <text key={i} x={380 + i * 40 - 6} y="315" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Supplier Lead Time */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Supplier Lead Time Performance</text>
          <rect x="16" y="344" width="668" height="1" fill="#e5e7eb" />
          {[
            { supplier: 'Tata Steel', lead: '4 days', ontime: '96%', status: '#16a34a' },
            { supplier: 'Hindalco', lead: '6 days', ontime: '88%', status: '#65a30d' },
            { supplier: 'Vedanta', lead: '9 days', ontime: '74%', status: '#ca8a04' },
            { supplier: 'JSW Group', lead: '12 days', ontime: '61%', status: '#dc2626' },
          ].map((s, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="362" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.supplier}</text>
              <text x={28 + i * 168} y="376" fill="#6b7280" fontSize="9" fontFamily="sans-serif">Lead: {s.lead}</text>
              <rect x={28 + i * 168} y="382" width="50" height="14" fill={s.status} rx="3" opacity="0.15" />
              <text x={28 + i * 168 + 4} y="393" fill={s.status} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s.ontime} OT</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Manufacturing Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
            Purpose-built dashboards for every decision-maker in your manufacturing organization.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d.title}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards[activeTab].title}</h3>
            <p className="text-charcoal/60 text-sm mt-1">{dashboards[activeTab].subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards[activeTab].svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="bg-navy hover:bg-navy/90 text-white text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              View Demo
            </button>
            <button className="border border-navy text-navy hover:bg-navy/5 text-sm font-semibold px-6 py-2.5 rounded-lg transition-all duration-200">
              Request Customization
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
